<script>
// import { SimpleBar } from "simplebar-vue3";
import { authMethods } from '@/state/helpers'
import api from '@/api'

/**
 * Topbar component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require('@/assets/images/flags/us.jpg'),
          language: 'en',
          title: 'English',
        },
        {
          flag: require('@/assets/images/flags/spain.jpg'),
          language: 'es',
          title: 'Spanish',
        },
        {
          flag: require('@/assets/images/flags/germany.jpg'),
          language: 'de',
          title: 'German',
        },
        {
          flag: require('@/assets/images/flags/italy.jpg'),
          language: 'it',
          title: 'Italian',
        },
        {
          flag: require('@/assets/images/flags/russia.jpg'),
          language: 'ru',
          title: 'Russian',
        },
      ],
      text: null,
      flag: null,
      value: null,
    }
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    layoutscroll: {
      type: Boolean,
      required: true,
    },
    pagetitle: {
      type: String,
      required: false,
    },
  },
  mounted() {},
  methods: {
    ...authMethods,
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    async logout() {
      await api.post(`${window.apiUrl}/admin/logout`).then(() => {
        this.authLogout()
        window.location.href = '/auth/login'
      })
    },
    toggleMenu() {
      this.$parent.toggleMenu()
    },
  },
  components: {
    // SimpleBar,
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'dark':
              document.body.setAttribute('data-topbar', 'dark')
              break
            case 'light':
              document.body.setAttribute('data-topbar', 'light')
              document.body.removeAttribute('data-layout-size', 'boxed')
              break
            default:
              document.body.setAttribute('data-topbar', 'dark')
              break
          }
        }
      },
    },
    layoutscroll: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case false:
              document.body.setAttribute('data-layout-scrollable', 'false')
              break
            case true:
              document.body.setAttribute('data-layout-scrollable', 'true')
              break
            default:
              document.body.setAttribute('data-layout-scrollable', 'false')
              break
          }
        }
      },
    },
  },
}
</script>

<template>
  <header id="page-topbar" class="isvertical-topbar">
    <div class="navbar-header">
      <div class="d-flex" style="width: 100% !important">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-lg">
              <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" />
            </span>
            <span class="logo-sm">
              <img src="@/assets/images/eze_nms_logo.svg" alt="" height="22" />
            </span>
          </router-link>
        </div>

        <button type="button" class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn topnav-hamburger" @click="toggleMenu">
          <span class="hamburger-icon open">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <div class="d-none d-sm-flex ms-3 align-self-center w-100">
          <h4 class="page-title mb-0" id="elePageTitle"></h4>
          <div class="ms-auto me-3" id="elePageAlert"></div>
        </div>
      </div>

      <div class="d-flex">
        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item user text-start d-flex align-items-center" id="page-header-user-dropdown-v" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="rounded-circle header-profile-user" src="@/assets/images/users/user.png" alt="Header Avatar" />
          </button>
          <div class="dropdown-menu dropdown-menu-end pt-0">
            <div class="p-3 border-bottom">
              <h6 class="mb-0">{{ authUser?.fullName }}</h6>
              <p class="mb-0 font-size-11 text-muted">{{ authUser?.email }}</p>
            </div>
            <!-- <router-link class="dropdown-item" to="/contacts/profile">
              <i class="mdi mdi-account-circle text-muted font-size-16 align-middle me-1"></i>
              <span class="align-middle">Profile</span>
            </router-link> -->
            <a class="dropdown-item" @click.prevent="logout()" href="">
              <i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
              <span class="align-middle">Logout</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
